import { moduleLogger } from "../util";

const log = moduleLogger.scope("fetch-retry");

export async function fetchRetry(url: string, init: RequestInit, retryOptions: RetryOptions): Promise<Response> {
	let updatedRetryOptions = retryOptions;
	if (!retryOptions.noRetryStatusCodes) {
		updatedRetryOptions = {
			...retryOptions,
			noRetryStatusCodes: DEFAULT_NO_RETRY_CODES,
		};
	}
	return retry(url, init, updatedRetryOptions);
}

export interface RetryOptions {
	limit: number;
	delay: number;
	timeout: number;
	noRetryStatusCodes?: number[];
}

const DEFAULT_NO_RETRY_CODES = [404, 408, 409, 413, 429, 500, 502, 503, 504, 521, 522, 524];

async function retry(url: string, init: RequestInit, retryOptions: RetryOptions, retryCount = 0): Promise<Response> {
	const urlMaybeWithRetryCount = retryCount > 0 ? `${url}&rc=${retryCount}` : url;
	if (retryCount < retryOptions.limit) {
		try {
			const response = await fetchTimeout(urlMaybeWithRetryCount, init, retryOptions.timeout);
			if ((response.status >= 200 && response.status <= 299) || retryOptions.noRetryStatusCodes?.includes(response.status)) {
				return response;
			}
		} catch (e) {
			/*       */
		}

		return await new Promise((resolve) => setTimeout(resolve, retryOptions.delay)).then(async () => await retry(url, init, retryOptions, retryCount + 1));
	}
	return fetchTimeout(urlMaybeWithRetryCount, init, retryOptions.timeout);
}

async function fetchTimeout(url: string, init: RequestInit, timeout: number): Promise<Response> {
	const abortController = new AbortController();
	const abortTimeout = setTimeout(() => {
		log.warn(`[fetch] Cancel fetch event to ${url}`);
		abortController.abort();
	}, timeout);

	try {
		return await fetch(url, { ...init, signal: abortController.signal });
	} finally {
		clearTimeout(abortTimeout);
	}
}
